<template>
    <div v-if="region !== 'de'" class="global-migration-landing min-h-screen">
        <!-- Hero Section -->
        <section
            class="hero-section min-h-[40vh] lg:min-h-[70vh] relative flex items-center justify-center bg-cover bg-center"
            :style="{ backgroundImage: `url(${$asset('/hkcm/images/miLandingPage/hero1.png', 'public')})` }"
        >
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full md:-mt-64 lg:-mt-60 xl:-mt-96">
                <div class="text-center text-white mt-4">
                    <h2 class="text-4xl md:text-6xl lg:text-7xl font-bold -mb-2 md:-mb-6 lg:-mb-8">Swiss Precision</h2>
                    <h2 class="text-4xl md:text-6xl lg:text-7xl font-bold mb-2">Global Vision.</h2>
                </div>
            </div>
        </section>

        <!-- Text + Video Section -->
        <section class="bg-[#353bee1d] py-12 md:py-16">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                    <!-- Left Column - Text Card (50%) -->
                    <div class="p-8 w-full rounded-lg">
                        <h3 class="text-xl md:text-2xl font-bold text-gray-900 mb-4">Market Intel becomes HKCM Global.</h3>
                        <p class="text-gray-700 leading-relaxed">
                            Market Intel takes the next step and becomes HKCM Global. Built on the reliability and neutrality of Swiss financial expertise, HKCM Global stands for
                            transparency, consistency, and trust. With access to more markets, deeper insights, and professional-grade analyses, you can trade with clarity and
                            confidence. But it gets better: As an existing customer, you'll receive the Tech33 package free for 12 months. As for everyone else, discover our
                            service today and save up to 40% on your purchase. HKCM Global. Swiss precision, global vision.
                        </p>
                    </div>

                    <!-- Right Column - Video (50%) with Frame -->
                    <div>
                        <div class="aspect-video rounded-lg overflow-hidden bg-gray-100">
                            <iframe
                                v-if="youtube"
                                class="w-full h-full"
                                src="https://www.youtube.com/embed/4AJ_qGPsoz8"
                                title="Market Intel Conversion"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin"
                                allowfullscreen
                            ></iframe>
                            <div v-else class="w-full h-full flex flex-col items-center justify-center p-4 text-center">
                                <p class="mb-4 text-gray-600 font-semibold">To watch this video, please accept functional cookies.</p>
                                <CookieReset />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Discount Countdown + CTA Section -->
        <section class="py-8 md:py-12">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex flex-col md:flex-row items-center justify-between gap-8">
                    <!-- Left Side - Countdown -->
                    <div class="flex-1">
                        <h3 class="text-blue text-xl md:text-2xl font-bold mb-4 text-center md:text-left">Discount-Countdown:</h3>
                        <div class="flex gap-4 justify-center md:justify-start">
                            <!-- Days -->
                            <div class="flex flex-col items-center">
                                <div class="countdown-box">
                                    <div class="countdown-number">{{ countdown.days }}</div>
                                </div>
                                <div class="countdown-label">Days</div>
                            </div>
                            <!-- Hours -->
                            <div class="flex flex-col items-center">
                                <div class="countdown-box">
                                    <div class="countdown-number">{{ countdown.hours }}</div>
                                </div>
                                <div class="countdown-label">Hours</div>
                            </div>
                            <!-- Minutes -->
                            <div class="flex flex-col items-center">
                                <div class="countdown-box">
                                    <div class="countdown-number">{{ countdown.minutes }}</div>
                                </div>
                                <div class="countdown-label">Minutes</div>
                            </div>
                            <!-- Seconds -->
                            <div class="flex flex-col items-center">
                                <div class="countdown-box">
                                    <div class="countdown-number">{{ countdown.seconds }}</div>
                                </div>
                                <div class="countdown-label">Seconds</div>
                            </div>
                        </div>
                    </div>

                    <!-- Right Side - CTA Button -->

                    <router-link
                        to="/produkte"
                        class="text-center mt-4Market Intel becomes HKCM GLOBAL animate-pulse flex-1 w-full bg-blue text-white font-bold py-4 px-6 rounded-lg shadow-lg hover:shadow-xl transition-all hover:bg-gray-50 hover:text-blue text-sm md:text-base"
                    >
                        CLICK HERE TO REDEEM YOUR 20% DISCOUNT<br />WITH CODE: LATEBIRD20
                    </router-link>
                </div>
            </div>
        </section>

        <!-- Four Feature Icon Tiles -->
        <section class="bg-white py-12 md:py-16">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    <!-- Feature 1 -->
                    <div
                        class="bg-[#353bee1d] p-6 rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer group hover:text-white hover:bg-blue-dark"
                        @click="
                            openModal(
                                '/hkcm/images/miLandingPage/marketIntel.png',
                                'Market Intel becomes HKCM GLOBAL',
                                'We’re giving you an even stronger platform with greater reliability, deeper\n' +
                                    'insights, and more opportunities for your financial freedom. At HKCM\n' +
                                    'Global, we offer professional market analyses that help you invest your\n' +
                                    'money more efficiently.\n' +
                                    'Our experts define clear entry areas and precise target zones to simplify\n' +
                                    'your trading decisions and improve timing accuracy.\n' +
                                    'With analyses on more than 190 markets worldwide, we provide you with\n' +
                                    'the clarity and confidence to act strategically — every day.\n' +
                                    'This transition from Market Intel to HKCM Global gives you access to a\n' +
                                    'broader, more sophisticated platform designed for your success in the\n' +
                                    'global capital markets.'
                            )
                        "
                    >
                        <div class="w-[80px] h-[80px] mx-auto mb-4 flex items-center justify-center bg-blue-dark group-hover:bg-white rounded-full">
                            <img class="w-12" :src="$asset('/hkcm/images/hkcm-logo.png', 'public')" alt="HKCM Logo" title="HKCM Logo" />
                        </div>
                        <h3 class="text-lg text-center mb-2">Market Intel becomes HKCM GLOBAL</h3>
                        <div class="text-sm font-semibold block text-center">Learn more.</div>
                    </div>

                    <!-- Feature 2 -->
                    <div
                        class="bg-[#353bee1d] p-6 rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer group hover:text-white hover:bg-blue-dark"
                        @click="
                            openModal(
                                '/hkcm/images/miLandingPage/tech33.png',
                                'Tech33 free for 12 months.\nSmarter insights. Precise analysis.',
                                'Your upgrade includes free access to our TECH33 analysis package for 12 months* — a curated set of 33 leading technology companies shaping software, AI, cloud, cybersecurity, payments, gaming, and mobility such as Apple, Microsoft, Nvidia, Meta, Tesla, Palantir, Snowflake, Shopify, Oracle, and Qualcomm. You’ll receive company deep-dives, market context, actionable entry areas and precise target zones, plus concise daily updates that help you make timely decisions.<br><br>*Only for existing customers.'
                            )
                        "
                    >
                        <div class="w-[80px] h-[80px] mx-auto mb-4 flex items-center justify-center bg-blue-dark group-hover:bg-white rounded-full">
                            <img class="w-12" src="https://hkcm-storage.s3.eu-central-1.amazonaws.com/products/tech-33-gradient.png" />
                        </div>
                        <h3 class="text-lg text-center mb-2">Our Tech33 package free for 12 months!*</h3>
                        <div class="text-sm font-semibold block text-center">Learn more.</div>
                    </div>

                    <!-- Feature 3 -->
                    <div
                        class="bg-[#353bee1d] p-6 rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer group hover:text-white hover:bg-blue-dark"
                        @click="
                            openModal(
                                '/hkcm/images/miLandingPage/envelope.png',
                                'Market Intel becomes HKCM GLOBAL',
                                'We’re giving you an even stronger platform with greater reliability, deeper insights, and more opportunities for your financial freedom. At HKCM Global, we offer professional market analyses that help you invest your money more efficiently.\n\nOur experts define clear entry areas and precise target zones to simplify your trading decisions and improve timing accuracy.\n\nWith analyses on more than 190 markets worldwide, we provide you with the clarity and confidence to act strategically — every day.\n\nThis transition from Market Intel to HKCM Global gives you access to a broader, more sophisticated platform designed for your success in the global capital markets.'
                            )
                        "
                    >
                        <div class="w-[80px] h-[80px] mx-auto mb-4 flex items-center justify-center bg-blue-dark group-hover:bg-white rounded-full">
                            <span class="text-white text-4xl font-bold -mt-2 group-hover:text-blue-dark">@</span>
                        </div>
                        <h3 class="text-lg text-center mb-2">No action required – automatic account migration.</h3>
                        <div class="text-sm font-semibold block text-center">Learn more.</div>
                    </div>

                    <!-- Feature 4 -->
                    <div
                        class="bg-[#353bee1d] p-6 rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer group hover:text-white hover:bg-blue-dark"
                        @click="
                            openModal(
                                '/hkcm/images/miLandingPage/sale-discount.png',
                                'Exclusive launch offer — up to 40% off',
                                'We’re giving you an even stronger platform with greater reliability, deeper insights, and more opportunities for your financial freedom. At HKCM Global, we offer professional market analyses that help you invest your money more efficiently.\n\nOur experts define clear entry areas and precise target zones to simplify your trading decisions and improve timing accuracy.\n\nWith analyses on more than 190 markets worldwide, we provide you with the clarity and confidence to act strategically — every day.\n\nThis transition from Market Intel to HKCM Global gives you access to a broader, more sophisticated platform designed for your success in the global capital markets.'
                            )
                        "
                    >
                        <div class="w-[80px] h-[80px] mx-auto mb-4 flex items-center justify-center bg-blue-dark group-hover:bg-white rounded-full">
                            <span class="text-white text-4xl font-bold group-hover:text-blue-dark">%</span>
                        </div>
                        <h3 class="text-lg text-center mb-2">Exclusive launch offer – up to 40 % off.</h3>
                        <div class="text-sm font-semibold block text-center">Learn more.</div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Team / People Image Strip -->
        <section class="py-12 md:py-16">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <img :src="$asset('/hkcm/images/miLandingPage/hero2.png', 'public')" alt="HKCM Global Team" class="w-full rounded-lg shadow-xl" />
            </div>
        </section>

        <!--FAQ Section -->
        <section class="bg-white py-12 md:py-16">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <h2>Frequently Asked Questions (FAQ)</h2>
                <div v-for="(faq, key) in faqs" :key="key">
                    <Accordeon :title="faq.q" :content="faq.a" />
                </div>
            </div>
        </section>

        <!-- Footer with Social + Newsletter -->
        <footer
            class="bg-white border-t border-gray-200 py-12 bg-no-repeat bg-right-top"
            :style="{ backgroundImage: `url(${$asset('/hkcm/images/miLandingPage/hero3.png', 'public')})` }"
        >
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-12">
                    <!-- Left Column - Social Media -->
                    <div>
                        <h3 class="text-2xl font-bold text-gray-900 mb-6">Join our Social Media:</h3>
                        <div class="flex flex-wrap justify-between bg-blue-dark p-4 rounded-lg shadow-lg">
                            <!-- Instagram -->
                            <a href="https://www.instagram.com/hkcm_global" target="_blank" rel="noopener noreferrer" class="text-center">
                                <p class="text-sm text-white font-semibold">hkcm_global</p>
                                <div class="text-4xl mx-auto">
                                    <i class="block fi fi-brands-instagram text-white" />
                                </div>
                            </a>

                            <!-- X (Twitter) -->
                            <a href="https://x.com/hkcm_global" target="_blank" rel="noopener noreferrer" class="text-center">
                                <p class="text-sm text-white font-semibold">hkcm_global</p>
                                <div class="text-4xl mx-auto">
                                    <i class="block text-white fi fi-brands-twitter-alt" />
                                </div>
                            </a>

                            <!-- YouTube -->
                            <a href="https://www.youtube.com/@HKCM_GLOBAL" target="_blank" rel="noopener noreferrer" class="text-center">
                                <p class="text-sm text-white font-semibold">hkcm_global</p>
                                <div class="text-4xl mx-auto">
                                    <i class="block text-white fi fi-brands-youtube" />
                                </div>
                            </a>
                        </div>
                    </div>

                    <!-- Right Column - Newsletter -->
                    <div>
                        <h3 class="text-2xl font-bold text-gray-900 mb-6">Sign up for our Newsletter:</h3>
                        <form class="flex flex-col sm:flex-row gap-4" @submit.prevent="handleNewsletterSubmit">
                            <input
                                v-model="email"
                                type="email"
                                placeholder="E-Mail*"
                                class="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                            <button
                                type="submit"
                                class="px-6 py-3 bg-blue-dark text-white font-bold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap"
                                :disabled="submitting"
                            >
                                {{ submitting ? 'Submitting...' : 'Sign up' }}
                            </button>
                        </form>

                        <p v-if="successMessage" class="mt-4 text-green-600 font-semibold">
                            {{ successMessage }}
                        </p>
                        <p v-if="errorMessage" class="mt-4 text-red-600 font-semibold">
                            {{ errorMessage }}
                        </p>
                    </div>
                </div>

                <!-- Bottom Text -->
                <div class="mt-12 pt-8 border-t border-gray-200">
                    <p class="text-center text-sm text-gray-600">*Terms & Conditions apply. Sample layout for HKCM Global migration landing page.</p>
                </div>
            </div>
        </footer>
    </div>
    <teleport to="body">
        <Popup :overflow-hidden="true" :open="modalOpen" class="px-6" @open="closeAction">
            <div class="flex 2xl:flex-row flex-col gap-4 p-8 items-center">
                <img :src="$asset(modalImage, 'public')" alt="HKCM Global Team" class="text-center max-h-[300px] xl:w-[50%] rounded-lg object-contain" />

                <div>
                    <h3>{{ modalTitle }}</h3>
                    <p v-html="modalDescription" />
                </div>
            </div>
        </Popup>
    </teleport>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import api from '../api.js';
import Accordeon from '../components/miscellaneous/Accordeon.vue';
import Popup from '../components/miscellaneous/Popup.vue';
import router from '../router.js';
import { useCcm19Global } from '../useCcm19Global.js';

defineOptions({
    name: 'GlobalMigrationLandingPage'
});

const countdown = reactive({
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00'
});

const email = ref('');
const submitting = ref(false);
const successMessage = ref('');
const errorMessage = ref('');
let countdownInterval = null;
const modalOpen = ref(false);
const modalImage = ref('');
const modalTitle = ref('');
const modalDescription = ref('');
const store = useStore();
const region = computed(() => window.meta?.region_configuration?.region || 'de');

const { onReady, youtube } = useCcm19Global();
onReady(() => {});



const faqs = [
    {
        q: 'Do I need a new account?',
        a: 'No – if you are an existing Market Intel customer, your account will be migrated automatically to HKCM Global. Your login details stay the same.'
    },
    {
        q: 'Will my account remain available?',
        a: 'Yes. Your account is still available and has been securely transferred to HKCM Global. Analyses for over 190 markets are now offered through our subscription plans.'
    },
    {
        q: 'What is the Tech33 package and who gets it for free?',
        a: 'All existing Market Intel customers receive the exclusive Tech33 analysis package free for 12 months. It includes insights on 33 leading technology companies and daily analysis updates. New users can purchase Tech33 as part of their subscription at a discounted launch rate.'
    },
    {
        q: 'Do I need to enter my payment details for the free year of Tech33?',
        a: 'No. You only need to provide your payment information if you want to continue using the Tech33 package after the free year.'
    },
    {
        q: 'What discounts are available?',
        a: 'During the launch, all users can benefit from: • 40% Early Bird discount (08.12.2025–21.12.2025) • 20% Late Bird discount (22.12.2025–04.01.2026)'
    },
    {
        q: 'Do I need to take any action during the migration?',
        a: 'No action is required. You’ll automatically gain access to HKCM Global and you can continue using our service seamlessly.'
    },
    {
        q: 'What additional benefits does HKCM Global offer?',
        a: 'HKCM Global provides access to analyses across more than 190 markets, clear entry areas and target zones, and exclusive video content — all designed to help you trade with precision and confidence.'
    },
    {
        q: 'How can I contact support if I have migration issues?',
        a: 'Our support team is available via email at support@hkcmglobal.com or directly through the HKCM Global contact form.'
    }
];

const startCountdown = () => {
    const countdownDate = new Date('2026-01-04 23:59:59');

    const updateCountdown = () => {
        const now = new Date().getTime();
        const distance = countdownDate.getTime() - now;

        if (distance < 0) {
            countdown.days = '00';
            countdown.hours = '00';
            countdown.minutes = '00';
            countdown.seconds = '00';

            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        countdown.days = String(days).padStart(2, '0');
        countdown.hours = String(hours).padStart(2, '0');
        countdown.minutes = String(minutes).padStart(2, '0');
        countdown.seconds = String(seconds).padStart(2, '0');
    };

    // Update immediately and then every second
    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);
};

const handleNewsletterSubmit = async () => {
    submitting.value = true;
    successMessage.value = '';
    errorMessage.value = '';

    try {
        api.post(`/api/v1/newsletters/subscribe`, {
            email: email.value,
            language: 'en'
        })
            .then((response) => {
                successMessage.value = 'Thank you for subscribing to our newsletter!';
                email.value = '';
            })
            .catch((error) => {
                console.error(error);
                errorMessage.value = 'An error occurred. Please try again.';
            });
    } catch (error) {
        console.error(error);
        errorMessage.value = 'An error occurred. Please try again.';
    } finally {
        submitting.value = false;
    }
};

const closeAction = () => {
    modalOpen.value = false;
};

const openModal = (image, title, description) => {
    modalImage.value = image;
    modalTitle.value = title;
    modalDescription.value = description;
    modalOpen.value = true;
};

onMounted(() => {
    if (region.value === 'de') {
        // redirect
        router.push('/');
    }

    startCountdown();
});

onBeforeUnmount(() => {
    if (countdownInterval) {
        clearInterval(countdownInterval);
    }
});
</script>

<style scoped>
.swiss-flag {
    width: 60px;
    height: 60px;
    background-color: #e53935;
    position: relative;
    display: inline-block;
}

.swiss-flag::before,
.swiss-flag::after {
    content: '';
    position: absolute;
    background-color: white;
}

.swiss-flag::before {
    width: 40px;
    height: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.swiss-flag::after {
    width: 10px;
    height: 40px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.countdown-box {
    background-color: white;
    border: 3px solid blue;
    box-shadow: 0 3px 5px rgba(59, 130, 246, 0.6);
    padding: 1rem;
    border-radius: 0.5rem;
    min-width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.countdown-number {
    font-size: 2rem;
    font-weight: bold;
    color: #031837;
}

.countdown-label {
    font-size: 0.875rem;
    color: #031837;
    margin-top: 0.5rem; /* Abstand zwischen Box und Label */
    font-weight: 600;
}
</style>
